"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformJournalEntryRequest = exports.transformJournalEntryParsedResponse = exports.transformJournalEntryResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Date_1 = require("./Date");
const Detail_1 = require("./Detail");
const Error_1 = require("./Error");
function transformJournalEntryResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { journal_entry } = response.response.result;
    return transformJournalEntryParsedResponse(journal_entry);
}
exports.transformJournalEntryResponse = transformJournalEntryResponse;
function transformJournalEntryParsedResponse(entry) {
    return {
        currencyCode: entry.currency_code,
        description: entry.description,
        details: entry.details && entry.details.map((detail) => (0, Detail_1.transformDetailParsedResponse)(detail)),
        entryId: entry.entryid,
        id: entry.id,
        name: entry.name,
        userEnteredDate: entry.user_entered_date && (0, Date_1.transformDateResponse)(entry.user_entered_date, Date_1.DateFormat['YYYY-MM-DD']),
    };
}
exports.transformJournalEntryParsedResponse = transformJournalEntryParsedResponse;
function transformJournalEntryRequest(entry) {
    return JSON.stringify({
        journal_entry: {
            currency_code: entry.currencyCode,
            description: entry.description,
            details: entry.details && entry.details.map((detail) => (0, Detail_1.transformDetailParsedRequest)(detail)),
            name: entry.name,
            user_entered_date: entry.userEnteredDate && (0, Date_1.transformDateRequest)(entry.userEnteredDate),
        },
    });
}
exports.transformJournalEntryRequest = transformJournalEntryRequest;
//# sourceMappingURL=JournalEntry.js.map